<template>
  <t-dropdown ref="categoryDropdown">
    <div slot="trigger" slot-scope="{ toggle, blurHandler }">
      <button
        @click="toggle"
        @blur="blurHandler"
        class="flex items-center focus:outline-none"
      >
        {{ selectedCategory }}
        <i class="material-icons">arrow_drop_down</i>
      </button>
    </div>
    <div
      v-for="(category, i) in categories"
      :key="i"
      class="text-black py-2 cursor-pointer hover:bg-gray-200"
      :class="{ 'rounded-t': i === 0 }"
      @click="filterCategories(category)"
    >
      {{ category }}
    </div>
    <button
      class="block w-full px-2 py-2 text-sm text-primary transition duration-150 ease-in-out border-t hover:bg-gray-200"
      @click="filterCategories()"
    >
      All Habits
    </button>
  </t-dropdown>
</template>

<script>
import categoryModule from '@/store/modules/category.module'
import habitModule from '@/store/modules/habit.module'

export default {
  name: 'CategoryDropdown',

  props: ['categories'],

  computed: {
    selectedCategory: categoryModule.selectedCategory
  },

  methods: {
    filterCategories(category = 'All Habits') {
      this.selectedCategory = category
      habitModule.selectFirstHabit()
      this.$refs.categoryDropdown.doHide()
    }
  }
}
</script>
